import * as vp from 'vopay';
import { useEffect, FunctionComponent, useState } from 'react';
import InteracBulkPayoutTransactionInfo from './InteracBulkPayoutTransactionInfo';
import useFetchInteracBulkPayoutTransaction from '../../../../hooks/useApi/useFetchInteracBulkPayoutTransaction';

type TransactionProps = {
  TransactionID: string;
  Notes?: string;
};
type FC = FunctionComponent<TransactionProps>;

const InteracBulkPayoutTransactionContainer: FC = (props: TransactionProps) => {
  const { TransactionID, Notes } = props;
  const [InteracBulkPayout, getInteracBulkPayoutTransaction] = useFetchInteracBulkPayoutTransaction({ bearer: '' });
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<vp.InteracBulkPayoutTransactionResponse>();

  useEffect(() => {
    getInteracBulkPayoutTransaction(TransactionID);
  }, [currentTransactionId]);

  useEffect(() => {
    if (InteracBulkPayout) {
      setTransaction(InteracBulkPayout);
    }
  }, [InteracBulkPayout]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
  }

  return <div>{transaction && <InteracBulkPayoutTransactionInfo transaction={transaction} Notes={Notes || ''} />}</div>;
};

export default InteracBulkPayoutTransactionContainer;
